import { render, staticRenderFns } from "./previewPage.vue?vue&type=template&id=350b7f8c&scoped=true&"
import script from "./previewPage.vue?vue&type=script&lang=js&"
export * from "./previewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350b7f8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VHover,VSheet})
